import * as React from 'react';

import {formatBytes} from './formatBytes';

const RESOURCE_POLLING_INTERVAL = 1000;

export interface SystemInfo {
    runtime: string;
    rvmVersion: string;
    cpuUsage: string;
    memUsage: string;
}

export function useSystemInfo(): SystemInfo {
    const [runtime, setRuntime] = React.useState<string>('...');
    const [rvmVersion, setRvmVersion] = React.useState<string>('...');
    const [cpuUsage, setCpuUsage] = React.useState<string>('...');
    const [memUsage, setMemUsage] = React.useState<string>('...');

    React.useEffect(() => {
        if (!window.fin) {
            return;
        }

        fin.System.getRuntimeInfo().then((runtimeInfo) => setRuntime(runtimeInfo.version));
        fin.System.getRvmInfo().then((rvmInfo) => setRvmVersion(rvmInfo.version));

        getProcessInfo().then((procInfo) => {
            setCpuUsage(procInfo.cpuUsage);
            setMemUsage(procInfo.memUsage);
        });
        const handle = setInterval(() => {
            getProcessInfo().then((procInfo) => {
                setCpuUsage(procInfo.cpuUsage);
                setMemUsage(procInfo.memUsage);
            });
        }, RESOURCE_POLLING_INTERVAL);

        return () => {
            clearInterval(handle);
        };
    }, []);

    return {runtime, rvmVersion, cpuUsage, memUsage};
}

async function getProcessInfo(): Promise<Pick<SystemInfo, 'cpuUsage' | 'memUsage'>> {
    const procList = await fin.System.getProcessList();
    const thisProc = procList.find((proc) => proc.uuid === fin.Window.me.uuid);

    return {
        cpuUsage: `${((thisProc && thisProc.cpuUsage) || 0).toFixed(1)}%`,
        memUsage: formatBytes((thisProc && thisProc.workingSetSize) || 0.0, 1)
    };
}
